module.exports = __webpack_public_path__ + "media/src/images/icons/white-chevron-right-60b37c93a46dec3437d3fdc67b7bdee1.svg";